import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../utils/baseURL";
import { setAlert } from "./alert.slice";
import Cookies from 'js-cookie';
import axiosInstance from "../../utils/axiosInstance";
const initialState = {
    Store: [],
    storee: [],
    purchase: [],
    wareHouse: [],
    users: [],
    success: false,
    message: '',
    loading: false,
    maxMinAvg: []
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    dispatch(setAlert({ text: errorMessage, color: 'error' }));
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const maxMinAvgPrice = createAsyncThunk(
    'store/maxMinAvgPrice',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/maxMinAvgPrice', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getstore = createAsyncThunk(
    'store/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/allstores', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.store;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getstoreItems = createAsyncThunk(
    'Allstores/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/allstoreItem', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.store;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const addstore = createAsyncThunk(
    'store/add',
    async (data, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(BASE_URL + '/createstore', data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getstore());
            return response.data.store;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deletestore = createAsyncThunk(
    'store/delete',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(`${BASE_URL}/deletestore/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            return id;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const editstore = createAsyncThunk(
    'store/edit',
    async (data, { dispatch, rejectWithValue }) => {
        try {
            const { _id, ...rest } = data;
            // console.log(data);
            const response = await axiosInstance.put(`${BASE_URL}/updatestore/${_id}`, rest, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getstore());
            return response.data.store;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getWarhouseData = createAsyncThunk(
    'store/getWarehouseData',
    async (id, { dispatch, rejectWithValue }) => {
        console.log("id", id);
        try {
            const response = await axiosInstance.get(`${BASE_URL}/getWarehouse/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            console.log("response", response.data);
            return response.data.store;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const transferStore = createAsyncThunk(
    'store/transfer',
    async (data, { dispatch, rejectWithValue }) => {
        try {
            console.log("data", data);
            const response = await axiosInstance.post(`${BASE_URL}/transferStore`, data, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            console.log("response", response.data);
            return response.data.store;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);


export const getstoreProduct = createAsyncThunk(
    'storeProduct/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getstoreProduct', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.products;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getstorepurchase = createAsyncThunk(
    'storepurchase/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getstorepurchase', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.purchase;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getstorewarehouse = createAsyncThunk(
    'storewarehouse/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getstorewarehouse', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.wareHouse;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getstoreUsers = createAsyncThunk(
    'storeUsers/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getstoreUsers', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.users;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);




const StoreSlice = createSlice({
    name: 'Store',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(maxMinAvgPrice.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Store...';
            })
            .addCase(maxMinAvgPrice.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                // state.message = action.payload?.message || 'Max Min Avg fetched successfully';
                state.maxMinAvg = action.payload;
            })
            .addCase(maxMinAvgPrice.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                // state.message = action.payload?.message || 'Failed to fetch Store';
            })
            .addCase(getstore.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Store...';
            })
            .addCase(getstore.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Store fetched successfully';
                state.Store = action.payload;
            })
            .addCase(getstore.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Store';
            })
            .addCase(getstoreItems.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Store...';
            })
            .addCase(getstoreItems.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Store Item fetched successfully';
                state.storee = action.payload;
            })
            .addCase(getstoreItems.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Store Item';
            })
            .addCase(addstore.pending, (state) => {
                state.loading = true;
                state.message = 'Adding Store...';
            })
            .addCase(addstore.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Store?.push(action.payload);
                state.message = action.payload?.message || 'Store added successfully';
            })
            .addCase(addstore.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to add Store';
            })
            .addCase(deletestore.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting Store...';
            })
            .addCase(deletestore.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Store = state.Store.filter((stores) => stores._id !== action.payload);
                state.message = action.payload?.message || 'Store deleted successfully';
            })
            .addCase(deletestore.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete Store';
            })
            .addCase(editstore.pending, (state) => {
                state.loading = true;
                state.message = 'Editing Store...';
            })
            .addCase(editstore.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Store = state.Store.map((stores) =>
                    stores._id === action.payload._id ? action.payload : stores
                );
                state.message = action.payload?.message || 'Store updated successfully';
            })
            .addCase(editstore.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update Store';
            })

            .addCase(getWarhouseData.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Warehouse Data...';
            })
            .addCase(getWarhouseData.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Warehouse Data fetched successfully';
                state.storee = action.payload;
            })
            .addCase(getWarhouseData.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Warehouse Data';
            })
            .addCase(transferStore.pending, (state) => {
                state.loading = true;
                state.message = 'Transferring Store...';
            })
            .addCase(transferStore.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Store transferred successfully';
                state.Store = action.payload;
            })
            .addCase(transferStore.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to transfer Store';
            })

            .addCase(getstoreProduct.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Store...';
            })
            .addCase(getstoreProduct.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Store fetched successfully';
                state.products = action.payload;
            })
            .addCase(getstoreProduct.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Store';
            })

            .addCase(getstorepurchase.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Store...';
            })
            .addCase(getstorepurchase.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Store fetched successfully';
                state.purchase = action.payload;
            })
            .addCase(getstorepurchase.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Store';
            })

            .addCase(getstorewarehouse.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Store...';
            })
            .addCase(getstorewarehouse.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Store fetched successfully';
                state.wareHouse = action.payload;
            })
            .addCase(getstorewarehouse.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Store';
            })
            .addCase(getstoreUsers.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Store...';
            })
            .addCase(getstoreUsers.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Store fetched successfully';
                state.users = action.payload;
            })
            .addCase(getstoreUsers.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Store';
            })

    }
});

export default StoreSlice.reducer;